import { Grid, Typography } from '@mui/material';
import { styled } from '@mui/material';
import Link from '@mui/material/Link';

interface FooterProps {
  drawerOpen: boolean;
}

const StyledFooter = styled('footer', {
  shouldForwardProp: (prop) => prop !== 'drawerOpen',
})<FooterProps>(({ theme, drawerOpen }) => ({
  ...(!drawerOpen && {
    textAlign: 'center',
    width: '100%',
    position: 'fixed',
    left: 0,
    bottom: 0,
    height: '1.5rem',
    zIndex: 99999,
  }),
  ...(drawerOpen && {
    textAlign: 'center',
    width: '100%',
    position: 'fixed',
    left: 120,
    bottom: 0,
    height: '1.5rem',
    zIndex: 99999,
  }),
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderRadius: '10px',
  padding: 2,
  paddingRight: 5,
  paddingLeft: 5,
  marginTop: 2,
}));

interface Props {
  drawerOpen: boolean;
}

const Footer = ({ drawerOpen }: Props) => {
  return (
    <StyledFooter drawerOpen={drawerOpen}>
      <Grid container justifyContent='center'>
        <StyledTypography variant='body2' color='textSecondary' align='center'>
          {'Copyright © '}
          <Link href='http://www.lptech.com' underline='hover'>
            LP Technologies, Inc.
          </Link>
          {' 2021'}
        </StyledTypography>
      </Grid>
    </StyledFooter>
  );
};

export default Footer;
